import "../stylesheets/product.scss";
import { ReactComponent as EditIcon } from "../assets/icons/edit.svg";
import { ReactComponent as RemoveIcon } from "../assets/icons/remove.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import { ReactComponent as ValidationIcon } from "../assets/icons/validation.svg";
import { isEditor } from "../services/utils";
import { useState, FormEvent } from "react";
import {
	deleteProduct,
	editProduct,
	moveProductDown,
	moveProductUp,
} from "../services/api";
import { useNotification } from "../contexts/NotificationContext";
import EditButton from "./EditButton";

// TYPES
type ProductProps = {
	name: string;
	ingredients: string[];
	price: number;
	id: string;
	isFeatured: boolean;
	onMoveUp?: () => void;
	onMoveDown?: () => void;
	onEdit?: (updated: {
		name: string;
		price: number;
		ingredients: string[];
		featured: boolean;
	}) => void;
};

// COMPONENT
function Product({
	name,
	ingredients,
	price,
	id,
	isFeatured,
	onMoveUp,
	onMoveDown,
	onEdit,
}: ProductProps) {
	const { notify } = useNotification();

	const [isEditing, setEditing] = useState<boolean>(false);
	const [featuredState, setFeaturedState] = useState<boolean>(isFeatured);
	const [deleted, setDeleted] = useState<boolean>(false);

	const handleEditing = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const formData = new FormData(e.currentTarget);

		const updatedName = formData.get("name") as string;
		const updatedPrice = parseFloat(formData.get("price") as string);
		const updatedIngredients = (formData.get("ingredients") as string)
			.split(",")
			.map((ing) => ing.trim());
		const featured = formData.get("featured") === "on";

		const updatedProduct = {
			id,
			name: updatedName,
			price: updatedPrice,
			ingredients: updatedIngredients,
			featured,
		};

		const response = await editProduct(updatedProduct);

		if (response) {
			notify({ type: "validation", title: "Produit Modifié !" });
			onEdit?.({
				name: updatedName,
				price: updatedPrice,
				ingredients: updatedIngredients,
				featured: featuredState,
			});
		} else {
			notify({
				type: "error",
				title: "Impossible de Modifier le produit...",
			});
		}

		// if (response) {
		// 	window.location.reload();
		// 	notify({ type: "validation", title: "Produit Modifié !" });
		// } else {
		// 	notify({
		// 		type: "error",
		// 		title: "Impossible de Modifier le produit...",
		// 	});
		// }

		setEditing(false);
	};

	const handleDeletion = async () => {
		const response = await deleteProduct(id);
		if (response) {
			setDeleted(true);
			notify({ type: "validation", title: "Produit Supprimé !" });
		} else {
			notify({
				type: "error",
				title: "Impossible de Supprimer le Produit...",
			});
		}
	};

	const handleMoveUp = async () => {
		const response = await moveProductUp(id);
		onMoveUp?.();
	};

	const handleMoveDown = async () => {
		const response = await moveProductDown(id);
		onMoveDown?.();
	};

	// TSX
	if (!deleted) {
		return (
			<form className="product" onSubmit={handleEditing}>
				{isEditing && (
					<button
						className="move-button"
						type="button"
						onClick={() => handleMoveUp()}
					>
						^
					</button>
				)}
				{isEditing ? (
					<div>
						<input
							className="primary-text"
							name="name"
							defaultValue={name}
						/>
						<div className="line" />
						<input
							className="primary-text"
							type="number"
							name="price"
							step=".01"
							defaultValue={price}
						/>
					</div>
				) : (
					<div>
						<span className="primary-text">{name}</span>
						<div className="line" />
						<span className="primary-text">{price}€</span>
					</div>
				)}

				<div className="ingredients">
					{isEditing ? (
						<textarea
							name="ingredients"
							defaultValue={ingredients.join(",")}
						></textarea>
					) : (
						<div>
							{ingredients.map((ing) => (
								<span className="secondary-text" key={ing}>
									{ing}
								</span>
							))}
						</div>
					)}
					{isEditor() && (
						<div className="edit-buttons">
							{isEditing && (
								<EditButton type="submit" variant="send" />
							)}
							<EditButton
								type="button"
								variant="edit"
								onClick={() => setEditing((prev) => !prev)}
							/>
							<EditButton
								type="button"
								variant="delete"
								onClick={() => handleDeletion()}
							/>
						</div>
					)}
				</div>
				{isEditing && (
					<div className="featured">
						{featuredState && (
							<input
								type="checkbox"
								name="featured"
								id="featured"
								checked
								onClick={() => setFeaturedState(!featuredState)}
							/>
						)}
						{!featuredState && (
							<input
								type="checkbox"
								name="featured"
								id="featured"
								onClick={() => setFeaturedState(!featuredState)}
							/>
						)}
						<label htmlFor="featured">featured</label>
					</div>
				)}
				{isEditing && (
					<button
						className="move-button"
						type="button"
						onClick={() => handleMoveDown()}
					>
						v
					</button>
				)}
			</form>
		);
	} else {
		return <div />;
	}
}

export default Product;
